import Image from 'next/image';
import React from 'react';
import { usePathname } from 'next/navigation';

import { IIconType } from '@/src/types';
import { cn } from '@/src/utils/utils';

type IInputSearchInputProps = {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string | null;
  icon: IIconType | null;
  onFocus: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
  onBlur: () => void;
};

export const InputSearchDestinationInput = ({
  search,
  setSearch,
  placeholder,
  icon,
  onFocus,
  onBlur,
}: IInputSearchInputProps) => {
  const pathname = usePathname();
  const showBorder = pathname.includes('destinations');

  return (
    <div
      className={cn(
        'flex justify-between rounded-lg border items-center bg-white',
        showBorder && 'border-light'
      )}
    >
      <input
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder={placeholder || ''}
        onFocus={onFocus}
        onBlur={onBlur}
        className="text-md w-full rounded-lg p-[15px] font-semibold tracking-tight text-gray !outline-none placeholder:text-base placeholder:font-semibold placeholder:text-neutral-400"
      />
      <div className="m-px flex size-16 max-h-[50px] max-w-[50px] cursor-pointer items-center justify-center rounded-md bg-primary active:bg-primary-dark">
        {icon && (
          <Image src={icon.icon} alt={icon.alt || ''} width={15} height={15} />
        )}
      </div>
    </div>
  );
};
